<div class="row row-sm add-form">
  <form autocomplete="off" class="p-0" novalidate [formGroup]="userForm">
    <div class="col-lg-12 col-md-12">
      <div class="card-body">
        <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
          <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
          <div class="ml-2">
            <h3 class="main-content-label mb-1"><b>
                User
              </b></h3>
            <p class="text-muted card-sub-title mb-0">
              Add New User Information
            </p>
          </div>
        </div>
        <div class="bc d-flex align-items-center pl-3" *ngIf="updateButton">
          <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
          <div class="ml-2">
            <h3 class="main-content-label mb-1"><b>
                User
              </b></h3>
            <p class="text-muted card-sub-title mb-0">
              Update Selected User Information
            </p>
          </div>
        </div>
        <!-- <div class="bc d-flex align-items-center pl-3" *ngIf="deleteButton">
                        <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>
                         User
                          </b></h3>
                          <p class="text-muted card-sub-title mb-0">
                            Delete Selected User Information
                          </p> 
                        </div>
                      </div> -->
        <hr>
        <div class="row clearfix">
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>
                  User Id
                </mat-label>
                <input required [readonly]="readonlyUpdate" onkeydown="return (event.keyCode!=13);" class="color"
                  type="text" maxlength="10" placeholder="User Id" formControlName="LoginName" matInput>
                <mat-error class="margin_tp"
                  *ngIf="userForm.controls['LoginName'].touched && userForm.controls['LoginName'].errors?.pattern">
                 Invalid
                </mat-error>
                <mat-error class="margin_tp"
                  *ngIf="userForm.controls['LoginName'].touched && userForm.controls['LoginName'].errors?.required">
                Mandatory
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>
                  User Full Name
                </mat-label>
                <input required onkeydown="return (event.keyCode!=13);" class="color" type="text" maxlength="50"
                  placeholder="User Full Name" formControlName="LoginFullName" matInput>
                <mat-error class="margin_tp"
                  *ngIf="userForm.controls['LoginFullName'].touched && userForm.controls['LoginFullName'].errors?.pattern">
                 Invalid
                </mat-error>
                <mat-error class="margin_tp"
                  *ngIf="userForm.controls['LoginFullName'].touched && userForm.controls['LoginFullName'].errors?.required">
                Mandatory
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="col-sm-4" *ngIf="hidePass">
            <div class="form-group">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>
                  Password
                </mat-label>
                <!-- <input  required onkeydown="return (event.keyCode!=13);" class="color" [type]="showPassword ? 'text' : 'password'" maxlength="5"
                  placeholder="Password" formControlName="LoginPass" matInput>
                   <i alt="show" class="fa fa-eye-slash eye" (click)="showPassword = !showPassword" [class.hide]="showPassword"></i>
                  <i alt="hide" class="fa fa-eye eye" (click)="showPassword = !showPassword" [class.hide]="!showPassword"></i> -->
                 
                  <input name="password" [type]="showPassword ? 'text' : 'password'" class="color" maxlength="5"
                  id="password-field"  onkeydown="return (event.keyCode!=13);" placeholder="Password" formControlName="LoginPass" matInput>
                <!-- <i class="fa fa-lock"></i> -->
                <i alt="show" class="fa fa-eye-slash eye" (click)="showPassword = !showPassword" [class.hide]="showPassword"></i>
                <i alt="hide" class="fa fa-eye eye" (click)="showPassword = !showPassword" [class.hide]="!showPassword"></i>
            
                  <mat-error class="margin_tp"
                  *ngIf="userForm.controls['LoginPass'].touched && userForm.controls['LoginPass'].errors?.pattern">
                 Invalid
                </mat-error>
                <mat-error class="margin_tp"
                  *ngIf="userForm.controls['LoginPass'].touched && userForm.controls['LoginPass'].errors?.required">
                Mandatory
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row col-sm-12">
            <div class="col-sm-12 prpl">
              <button *ngIf="updateButton && userUpdate" type="button" class="btn btn-primary btn-icon-text floatright mt-1 p-0 fr" (click)="Update()">
                <span style="display: contents; align-items: center;" class="p-0">
                  <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                  Update
                </span>
              </button>
              <button *ngIf="submitButton && userCreate" type="button" class="btn btn-primary btn-icon-text floatright mt-1 p-0 fr" (click)="submit()">
                <span style="display: contents; align-items: center;" class=" p-0">
                  <img width="20vh" src="../../assets/img/save.gif" class="p-0" style="margin-right: 5px;">
                  Save
                </span>
              </button>
              <button type="button" *ngIf="updateButton && userCreate" (click)="openPermission(userId)"
                class="btn btn-primary btn-icon-text floatright mt-1 p-0 mr-3 fr">
                <span style="display: contents; align-items: center;" class="p-0">
                  <img width="20vh" src="../../assets/img/settings.gif" style="margin-right: 5px;" class="p-0">
                  Permission
                </span>
              </button>
              <button  type="button" [mat-dialog-close]="true" class="btn btn-primary btn-icon-text floatright mr-3 mt-1 fr">
                <span style="display: contents; align-items: center;" class="p-0">
                  <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;" class="p-0">
                  Back
                </span>
              </button>
            </div>
          </div>  
          <!-- <div class="row">
            <div class="col-sm-3" *ngIf="updateButton"></div>
            <div class="col-sm-6" *ngIf="!updateButton"></div>
            <div class="col-sm-3 pri-0">
              <button type="button" [mat-dialog-close]="true" class="btn btn-primary btn-icon-text floatright mt-1 p-0">
                <span style="display: contents; align-items: center;" class="p-0">
                  <img width="20vh" src="../../assets/img/list.gif" style="margin-right: 5px;" class="p-0">
                  List
                </span>
              </button>
            </div>
            <div class="col-sm-3 pri-0" *ngIf="updateButton">
              <button type="button" (click)="openPermission(userId)"
                class="btn btn-primary btn-icon-text floatright mt-1 p-0">
                <span style="display: contents; align-items: center;" class="p-0">
                  <img width="20vh" src="../../assets/img/settings.gif" style="margin-right: 5px;" class="p-0">
                  Permission
                </span>
              </button>
            </div>
            <div class="col-sm-3 pri-0" *ngIf="submitButton">
              <button type="button" class="btn btn-primary btn-icon-text floatright mt-1 p-0" (click)="submit()">
                <span style="display: contents; align-items: center;" class=" p-0">
                  <img width="20vh" src="../../assets/img/save.gif" class="p-0" style="margin-right: 5px;">
                  Save
                </span>
              </button>
            </div>
            <div class="col-sm-3 pri-0" *ngIf="updateButton">
              <button type="button" class="btn btn-primary btn-icon-text floatright mt-1 p-0" (click)="Update()">
                <span style="display: contents; align-items: center;" class="p-0">
                  <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                  Update
                </span>
              </button>
            </div>
          </div> -->
        </div>



      </div>
    </div>
  </form>
</div>